import React from "react";
import styles from "../../stories/common/flipper-vault-card/index.module.scss";
import SkeletonC from "../../stories/common/skeleton";

export default function FlipperVaultCardSkeleton() {
  const arr = [
    {
      title: "Total Purchase PRE’s",
      value: 10
    },
    {
      title: "Total Purchase FT",
      value: 10
    },
    {
      title: "Total Sold",
      value: 2
    },
    {
      title: "Total Flipped",
      value: 1
    }
  ];
  return (
    <div className={styles.FlipperVaultCard}>
      <div className={styles.FlipperVaultCardHeader}>
        <img
          src="/images/flipper-vault-arrow.svg"
          alt=""
          className={styles.arrow}
        />
        <div className={styles.FlipperVaultCardContent}>
          <div>
            <SkeletonC width="83px" height="19px" />
            <div className={styles.FlipperVaultCardTitle}>
              <SkeletonC width="176px" height="26px" />
            </div>
            <div className={styles.FlipperVaultContactDropdown}>
              <SkeletonC width="128px" height="25px" />
            </div>
          </div>
          <div className={styles.FlipperVaultCardScore}>
            <SkeletonC width="99px" height="47px" />
          </div>
        </div>
      </div>
      <div className={styles.FlipperVaultCardInfo}>
        {arr.map((item) => (
          <div key={item.title}>
            <SkeletonC width="100%" height="39px" />
          </div>
        ))}
      </div>
      <div className={styles.FlipperVaultCardOwnerWrap}  style={{ marginBottom: "8px" }}>
        <SkeletonC width="125px" height="39px" />
      </div>
    </div>
  );
}
